import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Subtitle1, Body1 } from '@src/elements/typography/typography'
import { Icon } from '@src/elements/icon/icon'
import { Spacer } from '@src/elements/spacer/spacer'

import './error-screen.sass'

@Component
export class ErrorScreen extends Vue {

  @Prop({ required: false })
  protected title: string

  @Prop({ required: false })
  protected message: string

  @Prop({ required: false })
  private icon: string

  render (h: CreateElement) {
    return (
      <div class='error-screen'>
        {this.icon ? <Icon name={this.icon} class='error-icon' /> : null}

        {this.title ?
          <Subtitle1 align='center'>{this.title}</Subtitle1> : null}

        {this.message ?
          <Body1 align='center'>{this.message}</Body1> : null}

        <Spacer />

        <div class='contents'>
          {this.$slots.default}
        </div>
      </div>
    )
  }

}
